import React, {ReactNode, useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {SafeAreaView, ScrollView, View, StyleSheet} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {retrieveSetting, storeSetting} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTComboBox from '../Components/BTComboBox';
import {useGetEmployeesQuery} from '../redux/services/emmemployeeApi';
import {useGetPOAOutletsQuery} from '../redux/services/poaoutletApi';
import {useGetPOMTablesQuery} from '../redux/services/pomtableApi';
import {RootState} from '../redux/store';
import BTLinearGradient from '../Components/BTLinearGradient';
import {
  colors,
  spacing,
  shadows,
  borderRadius,
  typography,
} from '../theme/theme';

import { tp } from '../utils/translateText';
interface ColProps {
  children: ReactNode;
}

interface RowProps {
  children: ReactNode;
}

const Col: React.FC<ColProps> = ({children}) => {
  return <View style={{flex: 1}}>{children}</View>;
};

const Row: React.FC<RowProps> = ({children}) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        width: '100%',
        marginBottom: spacing.base,
        gap: spacing.sm,
      }}>
      {children}
    </View>
  );
};

const HomeScreen = ({navigation}: UniversalProps) => {
  const dispatch = useDispatch();
  const [skip, setSkip] = React.useState(true);
  const gdata = useSelector((state: RootState) => state.gdata);
  const {data: outletData} = useGetPOAOutletsQuery(gdata.company);
  const [multiOutlet, setMultiOutlet] = useState(false);
  const [defOutlet, setDefOutlet] = useState(0);

  const outlets = outletData?.map((value, i) => {
    return {
      label: value.ol_sname,
      id: value.ol_id,
      value: value,
    };
  });

  useEffect(() => {
    const temp: any = outlets;
    // Reset when the saved outlet is no longer in the user's permitted list.
    const stale =
      defOutlet != 0 &&
      temp?.length > 0 &&
      !temp.some((o: any) => Number(o.id) === Number(defOutlet));
    if (defOutlet == 0 || stale) {
      if (temp?.length > 0) {
        storeSetting('defoutlet', (temp[0].value.ol_id ?? 2).toString());
        setDefOutlet(temp[0].value.ol_id ?? 2);
      }
    } else {
      methods.setValue('outlet', defOutlet);
    }
    setMultiOutlet(temp?.length > 1);
  }, [outlets]);

  const cid = gdata.company;

  const {data: employeeData} = useGetEmployeesQuery(cid);
  const {data: tableData} = useGetPOMTablesQuery(
    {cid: gdata.company, olid: defOutlet}
  );

  useEffect(() => {
    const retDefOutlet = async () => {
      setDefOutlet(Number(await retrieveSetting('defoutlet')));
    };

    retDefOutlet();
    methods.setValue('outlet', defOutlet);
  }, []);

  const [defArea, setDefArea] = useState('');

  useEffect(() => {
    const retDefArea = async () => {
      setDefArea(await retrieveSetting('defarea'));
    };

    retDefArea();
    methods.setValue('area', defArea);
  }, []);

  const [defwaiter, setDefwaiter] = useState('0');

  useEffect(() => {
    const fetchdefwaiter = async () => {
      try {
        setDefwaiter(await retrieveSetting('defwaiter'));
      } catch (error) {
        console.error(error);
      }
    };

    fetchdefwaiter();
    methods.setValue('waiter', Number(defwaiter));
  }, []);

  useEffect(() => {
    methods.setValue('area', defArea);
  }, [defArea]);

  useEffect(() => {
    methods.setValue('waiter', Number(defwaiter));
  }, [defwaiter]);

  const {...methods} = useForm<any>({
    defaultValues: {outlet: defOutlet, area: defArea, waiter: defwaiter},
  });

  const sortedData = [...(Array.isArray(tableData) ? tableData : [])]?.sort(
    (a, b) => a.tb_sort - b.tb_sort,
  );

  const areaData = sortedData.filter(
    (value, index, self) =>
      index === self.findIndex(t => t.tb_areaname === value.tb_areaname),
  );

  const areas: any = areaData?.map((value, key) => {
    return {
      label: value.tb_areaname,
      id: value.tb_areaname,
      table: value,
    };
  });

  const waiters: any = employeeData?.map((value, key) => {
    return {
      label: value.em_name,
      id: value.em_id,
      table: value,
    };
  });

  return (
    <BTLinearGradient
      colors={colors.primaryGradient}
      style={screenStyles.gradient}>
      <ScrollView
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={screenStyles.scrollContent}>
        <SafeAreaView style={screenStyles.safeArea}>
          <View style={screenStyles.container}>
            <FormProvider {...methods}>
              {gdata.menu?.find(
                v => v.mn_link == '/transaction/potablelist',
              ) ? (
                <>
                  {multiOutlet ? (
                    <Row>
                      <Col>
                        <BTComboBox
                          name="outlet"
                          label="Outlet"
                          data={outlets}
                          placeholder={tp("Outlet Name")}
                          onValChange={async (v: any) => {
                            setDefOutlet(v);
                            await storeSetting('defoutlet', v.toString());
                          }}
                        />
                      </Col>
                    </Row>
                  ) : null}
                  <Row>
                    <Col>
                      <BTComboBox
                        name="area"
                        label="Area"
                        data={areas}
                        placeholder={tp("Area Name")}
                        onValChange={async (v: any) => {
                          await storeSetting('defarea', v);
                        }}
                      />
                    </Col>
                    <Col>
                      <BTComboBox
                        name="waiter"
                        label="Captain"
                        data={waiters}
                        placeholder={tp("Captain Name")}
                        onValChange={async (v: any) => {
                          await storeSetting('defwaiter', v.toString());
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : null}
            </FormProvider>
            <View style={screenStyles.buttonContainer}>
              <BTButton
                onPress={() => navigation.navigate('Tables')}
                onLongPress={() => {}}
                title={'Tables'}
                color="#146C94"
                style={screenStyles.button}
              />
              <BTButton
                onPress={() => navigation.navigate('DashboardPOS')}
                onLongPress={() => {}}
                title={'DashBoard'}
                color="#146C94"
                style={screenStyles.button}
              />
            </View>
          </View>
        </SafeAreaView>
      </ScrollView>
    </BTLinearGradient>
  );
};

const screenStyles = StyleSheet.create({
  gradient: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingBottom: 80,
  },
  safeArea: {
    flex: 1,
  },
  container: {
    paddingTop: spacing.xl,
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    borderRadius: borderRadius['2xl'],
    marginHorizontal: spacing.sm,
    marginVertical: spacing.md,
    paddingHorizontal: spacing.base,
    paddingVertical: spacing.xl,
    ...shadows.lg,
    borderWidth: 1,
    borderColor: 'rgba(232, 213, 255, 0.3)',
    flexGrow: 1,
    width: '98%',
    maxWidth: '98%',
    minHeight: 400,
  },
  buttonContainer: {
    width: '100%',
    marginTop: spacing.lg,
    gap: spacing.base,
  },
  button: {
    marginBottom: spacing.md,
    width: '100%',
  },
});

export default HomeScreen;

